import { useNavigate } from "react-router-dom";
import { LayoutDashboard, LogIn, UserPlus, UserCircle } from "lucide-react";

import { DropdownMenu, type DropdownMenuItemSpec } from "./DropdownMenu";

/**
 * Menu déroulant du visiteur **anonyme** (S16-2).
 *
 * Décision PO 2026-06-12 (« tout dans l'avatar ») : le visiteur anonyme garde
 * la **même structure** que le compte connecté (barre minimale + dropdown).
 * Le dropdown anonyme expose ce qui a du sens pour une session non
 * authentifiée :
 * - **Tableau de bord** → `/app` (le dashboard de la session anonyme).
 * - **Se connecter** → `/login` (CTA existant, inchangé).
 * - **Créer un compte** → `/signup` (CTA existant, inchangé).
 *
 * Toute l'a11y clavier est portée par `DropdownMenu` (identique au menu
 * connecté).
 */
export function AnonymousMenu(): JSX.Element {
  const navigate = useNavigate();

  const items: DropdownMenuItemSpec[] = [
    {
      label: "Tableau de bord",
      icon: <LayoutDashboard className="h-4 w-4" aria-hidden />,
      onSelect: () => navigate("/app"),
    },
    {
      label: "Se connecter",
      icon: <LogIn className="h-4 w-4" aria-hidden />,
      onSelect: () => navigate("/login"),
    },
    {
      label: "Créer un compte",
      icon: <UserPlus className="h-4 w-4" aria-hidden />,
      onSelect: () => navigate("/signup"),
    },
  ];

  return (
    <DropdownMenu
      id="anonymous-menu"
      triggerAriaLabel="Compte"
      triggerContent={
        <>
          <UserCircle className="h-4 w-4" aria-hidden />
          <span>Compte</span>
        </>
      }
      items={items}
    />
  );
}
